module.exports = __webpack_public_path__ + "media/images/fresh-partner-8278d24775f8b1f04219346faf2869a0.png";